module.exports = __webpack_public_path__ + "img/Kidney_beans.c62ca7e1.jpg";